import { useMemo } from 'react'

import { IApiDataType, IExrayDataType } from '../types'
import { IAiSummaryType as IBbbAiSummaryType, hooks as bbbHooks } from './bbb'
import {
  IAiSummaryType as ICommonAiSummaryType,
  hooks as commonHooks,
} from './common'
import {
  IAiSummaryType as IFwWingstopAiSummaryType,
  hooks as fwWingstopHooks,
} from './fw_wingstop'
import {
  IAiSummaryType as IGhaiPopAiSummaryType,
  hooks as ghaiPopHooks,
} from './ghaiPop'
import {
  IAiSummaryType as IWingitnorthAiSummaryType,
  hooks as wingitnorthHooks,
} from './wingitnorth'

export type IAiSummaryType =
  | ICommonAiSummaryType
  | IBbbAiSummaryType
  | IGhaiPopAiSummaryType
  | IFwWingstopAiSummaryType
  | IWingitnorthAiSummaryType

interface IDataType extends IExrayDataType {
  type: Extract<IAiSummaryType, string>
}

interface IAiSummaryDataType {
  data: IDataType[] | null
  loading: boolean
}

const hooks = [
  ...commonHooks,
  ...bbbHooks,
  ...ghaiPopHooks,
  ...fwWingstopHooks,
  ...wingitnorthHooks,
] as [IDataType['type'], (options?: IAiSummaryType) => IApiDataType][]

const useApi = (types: IAiSummaryType[]): IAiSummaryDataType => {
  const aiSummaries: [IDataType['type'], IApiDataType][] = []

  for (const [type, hook] of hooks) {
    const option = types.find((t) => t === type)

    if (option) aiSummaries.push([type, hook(option)])
  }

  return useMemo(
    () =>
      aiSummaries.reduce(
        (result, [type, { data, loading }]) => ({
          data: !data
            ? result.data
            : [...(result.data || []), { ...data, type }],
          loading: result.loading || loading,
        }),
        {
          data: null,
          loading: false,
        } as IAiSummaryDataType,
      ),
    aiSummaries,
  )
}

export default useApi
